import React from 'react';

import {
  Container, Text, Links, Link, Item,
} from './styles';

const d = new Date();
const year = d.getFullYear();

const Footer = () => (
  <Container>
    <Text>
      NATIONAL POWERSPORT AUCTIONS ©
      {year}
      . ALL RIGHTS RESERVED
    </Text>
    <Links>
      <Item>
        <Link href="https://www.npauctions.com/cp/eSaleTerms#/AuctionFees" target="_blank">DEALER TERMS & CONDITIONS</Link>
&nbsp;|&nbsp;
      </Item>
      <Item><Link href="https://www.npauctions.com/cp/NPAWebsiteTermsofUse" target="_blank">WEBSITE TERMS OF USE</Link></Item>
    </Links>
    <Links>
      <Item>
        <Link href="https://www.npauctions.com/cp/NPAprivacypolicy" target="_blank">PRIVACY POLICY</Link>
&nbsp;|&nbsp;
      </Item>
      <Item>
        <Link href="https://www.npauctions.com/cp/cookiespolicy" target="_blank">COOKIES POLICY</Link>
&nbsp;|&nbsp;
      </Item>
      <Item>
        <Link href="https://www.npauctions.com/cp/Accessibility" target="_blank">ACCESSIBILITY</Link>
        &nbsp;|&nbsp;
      </Item>
      <Item>
        <Link href="https://www.npauctions.com/cp/DSLicenseAgreement" target="_blank">DATA SERVICES AGREEMENT</Link>
            &nbsp;|&nbsp;
      </Item>
      <Item>v1.0.12</Item>
    </Links>
  </Container>
);

export default Footer;
